<template>
  <div class="flex flex-col space-y-1" :class="[classes]">
    <LabelReset
      v-if="label"
      :initialValue="initialValue"
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
    >
      {{ label }}
    </LabelReset>
    <textarea
      type="text"
      class="font-sans placeholder:text-fg-placeholder rounded border-solid border border-linear-subtle px-4 py-3 bg-surface-primary"
      :placeholder="placeholder"
      :value="modelValue"
      @input.stop.prevent="onChange"
      :class="[textareaClasses]"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import LabelReset from '@/common/components/molecules/LabelReset.vue'

export default defineComponent({
  name: 'TextareaInput',
  components: { LabelReset },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    initialValue: {
      required: false,
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    classes: {
      type: String,
      required: false,
    },
    textareaClasses: {
      type: String,
      required: false,
    },
  },
  emits: {
    'update:modelValue'(value: string) {
      return typeof value === 'string'
    },
  },
  methods: {
    onChange(event) {
      this.$emit('update:modelValue', event.target.value)
    },
  },
})
</script>
